import { Heading } from 'almanac-ui/Heading/Heading'

import Styles from './Empty.module.scss'
import { Button } from 'blaze-ui/Button'

const EMPTY_STATE_IMAGE =
  'https://res.cloudinary.com/almanac/image/upload/v1697726677/blaze_assets/empty-state-image_xh0twt.png'

interface Props {
  query: string
  onReset: () => void
}

export const Empty = ({ query, onReset }: Props) => {
  return (
    <div className={Styles.emptyContainer}>
      <div className={Styles.empty}>
        <img src={EMPTY_STATE_IMAGE} alt="No results" />
        <div className={Styles.query}>"{query}"</div>
      </div>
      <div className={Styles.emptyText}>
        <Heading level={4}>No files matching the search text. Try another search</Heading>
        <div className={Styles.actions}>
          <Button variant="secondary" size="lg" onPress={onReset}>
            Clear Search
          </Button>
        </div>
      </div>
    </div>
  )
}
